import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaRegClock, FaUserEdit, FaFileInvoice, FaTag } from "react-icons/fa";
import moment from "moment";
import { BsPencil, BsCheck, BsX } from "react-icons/bs";
import { Row, Col, Form, Card } from "react-bootstrap";
const DealView = ({ data, dealId, setDealDetails }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [editedDealData, setEditedDealData] = useState(data);
    const [organisations, setOrganisation] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState(data?.product_item_details || []);
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [allProducts, setAllProducts] = useState([]);
    const didFetchRef = useRef(false);
    const [isProductModalOpen, setIsProductModalOpen] = useState(false);
    const [partners, setPartner] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [editField, setEditField] = useState(null);
    const [hoveredField, setHoveredField] = useState(null);
    const [activeTab, setActiveTab] = useState('dealView');
    const [timelineUpdates, setTimelineUpdates] = useState([]);
    const fetchContacts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/contact`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,


            });

            // const filteredContacts = response.data.Data.filter(
            //     contact => contact.type !== "instance" && contact.type !== "tenant"
            // );

            setContacts(response.data.Data);

        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    const fetchOrganisation = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,


            });

            const data = response.data.data;

            setOrganisation(data);

        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };



    useEffect(() => {
        if (!didFetchRef.current) {
            fetchOrganisation();
            fetchContacts();
            didFetchRef.current = true;
        }
    }, []);
    const getIcon = (action) => {
        switch (action) {
            case "Deal Created":
                return <FaRegClock className="icon created" />;
            case "Deal Updated":
                return <FaUserEdit className="icon updated" />;
            case "Product Added":
                return <FaFileInvoice className="icon invoice" />;
            case "status":
                return <FaTag className="icon status" />;
            default:
                return <FaRegClock className="icon default" />;
        }
    };
    const groupByDate = (updates) => {
        return updates.reduce((grouped, update) => {
            const date = moment(update.created_at).format("MMM DD, YYYY");
            if (!grouped[date]) {
                grouped[date] = [];
            }
            grouped[date].push(update);
            return grouped;
        }, {});
    };
    const groupedUpdates = groupByDate(timelineUpdates);

    const getProbability = (stage) => {
        const probabilities = {
            suspect: 10,
            prospect: 25,
            approach: 50,
            negotiation: 75,
            "closed won": 90,
            "closed lost": 0,
            "closed dead": 0,
            order: 100,
        };
        return probabilities[stage] || 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newDealData = { ...editedDealData, [name]: value };

        if (name === 'stage') {
            const probability = getProbability(value);
            newDealData.probability = probability;
        }

        if (name === 'value' || name === 'stage') {
            const dealValue = parseFloat(newDealData.value) || 0;
            const probability = parseFloat(newDealData.probability) || 0;
            newDealData.expected_revenue = ((dealValue * probability) / 100).toFixed(2);
        }

        if (name === "lead_source") {
            newDealData.contact_id = "";
        }
        setEditedDealData(newDealData);
    };


    const handleSave = async () => {
        try {
            const dataToUpdate = { ...editedDealData };

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            console.log('Data sent to backend:', dataToUpdate);
            await axios.put(`${backendUrl}/api/deals/${dealId}`, dataToUpdate, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });

            setDealDetails((prevDetails) => ({
                ...prevDetails,
                ...dataToUpdate, // Update only the changed fields
            }));



            setEditField(null);
        } catch (error) {
            console.error('Error saving client details:', error);
        }
    };

    const openProductModal = () => {
        setIsProductModalOpen(true);
    };

    const closeProductModal = () => {
        setIsProductModalOpen(false);
    };

    const addProductToDeal = (product) => {
        setSelectedProducts([...selectedProducts, { product, quantity: 1, total: product.price }]);
    };

    const availableProducts = allProducts.filter(prod =>
        !selectedProducts.some(sel => sel.product.id === prod.id)
    );

    const partnerOrganisations = organisations?.filter(org => org.org_type === 'partner');
    const getPartnerName = (id) => {
        if (!id) return "--";
        const partner = partnerOrganisations.find((p) => Number(p.id) === Number(id));
        return partner ? partner.name : "--";
    };
    const getOrgName = (id) => {
        if (!id) return "--";
        const contact = organisations.find((c) => Number(c.id) === Number(id));
        return contact ? contact.name : "--";
    };
    const getContactName = (id) => {
        if (!id) return "--";
        const contact = contacts.find((c) => Number(c.id) === Number(id));
        return contact ? contact.name : "--";
    };
    const getLeadSourceLabel = (leadSource) => {
        switch (leadSource) {
            case 'consultant': return 'Consultant Name';
            case 'inside sales': return 'Inside Sales';
            case 'sales generated': return 'Sales Generated ';
            default: return 'Lead Source Name';
        }
    };
    const fields = [
        { name: 'name', label: 'Name', type: 'text' },
        { name: "organisation_id", label: "Organisation", type: "select", options: organisations.map(org => ({ value: org.id, label: org.name })) },
        { name: 'customer_type', label: 'Customer Type', type: 'select', options: [{ value: "existing customer", label: "Existing Customer" }, { value: "new customer", label: "new customer" },] },
        {
            name: "lead_source",
            label: "Lead Source",
            type: "select",
            options: [
                { value: "consultant", label: "Consultant" },
                { value: "partner", label: "Partner" },
                { value: "inside sales", label: "Inside Sales" },
                { value: "sales generated", label: "Sales Generated" }
            ]
        }, { name: 'partner_id', label: 'Partner Name', type: 'select', options: partnerOrganisations.map(partner => ({ value: partner.id, label: partner.name })) },
        {
            name: 'type_id',
            label: getLeadSourceLabel(editedDealData.lead_source),  // Dynamically updates label
            type: 'select',
            options: (() => {
                const leadSource = editedDealData.lead_source?.toLowerCase();


                if (leadSource === "consultant") {
                    return contacts
                        .filter(contact =>
                            contact.contact_type?.toLowerCase() === "external" &&
                            (contact.type?.name?.toLowerCase() || "") === "consultant"
                        )
                        .map(contact => ({ value: contact.id, label: contact.name }));
                }
                else if (leadSource === "inside sales") {
                    return contacts
                        .filter(contact =>
                            contact.contact_type?.toLowerCase() === "internal" &&
                            (contact.type?.name?.toLowerCase() || "") === "inside sales"
                        )
                        .map(contact => ({ value: contact.id, label: contact.name }));
                }
                else if (leadSource === "sales generated") {
                    return contacts
                        .filter(contact =>
                            contact.contact_type?.toLowerCase() === "internal" &&
                            (contact.type?.name?.toLowerCase() || "") === "sales generated"
                        )
                        .map(contact => ({ value: contact.id, label: contact.name }));
                }
                else {
                    const selectedOrg = organisations.find(
                        org => String(org.id) === String(editedDealData.organisation_id)
                    );
                    return (selectedOrg?.contacts || []).map(contact => ({
                        value: contact.id,
                        label: contact.name
                    }));
                }

                return [];
            })()
        },

        { name: 'closed_date', label: 'Closed Date', type: 'date' },

        {
            name: 'stage', label: 'Stage', type: 'select', options:
                [{ value: "suspect", label: "Suspect" },
                { value: "prospect", label: "Prospect" },
                { value: "approach", label: "Approach" },
                { value: "negotiation", label: "Negotiation" },
                { value: "closed won", label: "Closed Won" },
                { value: "closed lost", label: "Closed Lost" },
                { value: "closed dead", label: "Closed Dead" },
                { value: "order", label: "Order" },
                ]
        },

        { name: 'value', label: 'Value', type: 'text' },
        { name: 'probability', label: 'Probability(%)', type: 'text' },
        { name: 'expected_revenue', label: 'Expected Revenue', type: 'text' },
        { name: 'next_steps', label: 'Next Step', type: 'text' },
        { name: 'remarks', label: 'Remarks', type: 'text' },
        { name: 'sales_cycle', label: 'Sales Cycle', type: 'text' },
        // { name: 'partner_name', label: 'Partner Name', type: 'text' },

        { name: 'created_at', label: 'Created Date', type: 'text', readOnly: true },
    ];

    const visibleFields = fields.filter((field) => {
        if (field.name === "sales_cycle") {
            return true;
        }
        // Conditionally exclude the vendor_id field if inhouse is '1'
        if (field.name === 'partner_id') {
            return editedDealData.lead_source === 'partner';
        }
        if (field.name === "type_id") {
            return ["consultant", "inside sales", "sales generated"].includes(editedDealData.lead_source);
        }
        return true;
    });

    const rows = [];
    for (let i = 0; i < visibleFields.length; i += 3) {
        rows.push(visibleFields.slice(i, i + 3));
    }
    const getDisplayValue = (field, value) => {
        if (!value) return "--";

        switch (field.name) {
            case "partner_id":
                return getPartnerName(value);
            case "contact_id":
                return getContactName(value);
            case "organisation_id":
                return getOrgName(value);
            case "created_at":
                return moment(value).format('DD-MM-YYYY');
            default:
                return value || "--";
        }
    };

    // return (
    //     <div className="p-3  font-size-13">
    //         <Row>
    //             {visibleFields.map((field, index) => (
    //                 <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
    //                     <strong className="view-label">
    //                         {field.label}:
    //                     </strong>
    //                     <div className="editable-container d-flex align-items-center">
    //                         {editField === field.name ? (
    //                             <div className="d-flex align-items-center">
    //                                 {field.type === "select" ? (
    //                                     <Form.Select
    //                                         name={field.name}
    //                                         value={editedDealData[field.name] || ""}
    //                                         onChange={handleChange}
    //                                         autoFocus
    //                                         className="form-control form-feild"
    //                                         >
    //                                         <option value="">Select</option>
    //                                         {field.options.map((option) => (
    //                                             <option key={option.value} value={option.value}>
    //                                                 {option.label}
    //                                             </option>
    //                                         ))}
    //                                     </Form.Select>
    //                                 ) : (
    //                                     <Form.Control
    //                                         type="text"
    //                                         name={field.name}
    //                                         value={editedDealData[field.name] || ""}
    //                                         onChange={handleChange}
    //                                         autoFocus
    //                                         className="form-control form-feild"
    //                                         />
    //                                 )}
    //                                 <BsCheck className="text-success mx-2" onClick={handleSave} style={{ cursor: "pointer" }} />
    //                                 <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
    //                             </div>
    //                         ) : (
    //                             <div className="hover1" onClick={() => setEditField(field.name)}>
    //                                 <span className="hover-field1">
    //                                     {field.name === "partner_id" ? getPartnerName(editedDealData[field.name]) :
    //                                         field.name === "type_id" ? getContactName(editedDealData[field.name]) :
    //                                             field.name === "organisation_id" ? getOrgName(editedDealData[field.name]) :
    //                                                 editedDealData[field.name] || "--"}
    //                                 </span>
    //                                 <BsPencil className="text-primary pencil-icon1" />
    //                             </div>
    //                         )}
    //                     </div>
    //                 </Col>
    //             ))}
    //         </Row>
    //     </div>
    // );

    return (
        <div className="p-3">
            <Card className="border-0 shadow-sm">
                <Card.Header className="bg-white border-bottom py-3">
                    <h6 className="mb-0 fw-bold text-dark">Lead Information</h6>
                    <small className="text-muted">Manage lead details and properties</small>
                </Card.Header>
                <Card.Body className="p-0">
                    <div className="p-3">
                        <Row>
                            {visibleFields.map((field, index) => (
                                <Col md={6} key={index} className="mb-3">
                                    <div
                                        className="lead-field-card p-3 border rounded h-100"
                                        onMouseEnter={() => setHoveredField(field.name)}
                                        onMouseLeave={() => setHoveredField(null)}
                                        style={{
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            backgroundColor: hoveredField === field.name ? '#f8f9fa' : 'white'
                                        }}
                                    >
                                        <div className="d-flex justify-content-between align-items-start">
                                            <div className="flex-grow-1">
                                                <label className="form-label text-muted small mb-2 fw-semibold">
                                                    {field.label}
                                                </label>
                                                {editField === field.name && !field.readOnly ? (
                                                    <div className="d-flex align-items-center gap-2 mt-2">
                                                        {field.type === "select" ? (
                                                            <Form.Select
                                                                name={field.name}
                                                                value={editedDealData[field.name] || ""}
                                                                onChange={handleChange}
                                                                autoFocus
                                                                className="form-control-sm"
                                                                size="sm"
                                                            >
                                                                <option value="">Select {field.label}</option>
                                                                {field.options.map((option) => (
                                                                    <option key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        ) : field.type === "textarea" ? (
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={2}
                                                                name={field.name}
                                                                value={editedDealData[field.name] || ""}
                                                                onChange={handleChange}
                                                                autoFocus
                                                                className="form-control-sm"
                                                            />
                                                        ) : (
                                                            <Form.Control
                                                                type={field.type}
                                                                name={field.name}
                                                                value={editedDealData[field.name] || ""}
                                                                onChange={handleChange}
                                                                autoFocus
                                                                className="form-control-sm"
                                                            />
                                                        )}
                                                        {/* <div className="d-flex gap-1">
                                                                <BsCheck 
                                                                    className="text-success" 
                                                                    onClick={handleSave} 
                                                                    style={{ cursor: "pointer", fontSize: "18px" }} 
                                                                />
                                                                <BsX 
                                                                    className="text-danger" 
                                                                    onClick={() => setEditField(null)} 
                                                                    style={{ cursor: "pointer", fontSize: "18px" }} 
                                                                />
                                                            </div> */}
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="editable-field d-flex align-items-center justify-content-between mt-1"
                                                    >
                                                        <span className="text-dark fw-semibold">
                                                            {getDisplayValue(field, editedDealData[field.name])}
                                                        </span>
                                                        {/* <BsPencil 
                                                                className="text-primary ms-2" 
                                                                size={14} 
                                                                style={{ 
                                                                    opacity: hoveredField === field.name ? 1 : 0,
                                                                    transition: 'opacity 0.2s ease'
                                                                }} 
                                                            /> */}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );

};





export default DealView;



